import { z } from "zod";

/**
 * Микрофон участника комнаты, которым распоряжается преподаватель:
 * `POST /v1/lessons/:lessonId/participants/:userId/mic`.
 *
 * Отдельным файлом от `token.ts`, хотя обе схемы про одну и ту же комнату SFU:
 * там пропуск в комнату, здесь распоряжение внутри неё, и читателю удобнее по
 * этой границе, а не по числу строк.
 *
 * ⚠️ **Состояние микрофона живёт в комнате SFU и в базе не хранится.** Разбор
 * размена стоит в самой ручке (`routes/lessons/room.ts`), здесь важно
 * следствие для контракта: ответ описывает комнату в момент запроса, а не
 * настройку ученика.
 */

/**
 * `on` это «микрофон разрешён», а не «микрофон включён»: включает его ученик
 * сам, удалённо мы чужой микрофон не включаем никогда.
 */
export const MicRequest = z.object({ on: z.boolean() });
export type MicRequest = z.infer<typeof MicRequest>;

/**
 * Чей микрофон и что с ним стало.
 *
 * `userId` в ответе, хотя он же стоит в адресе: ответы приходят вразнобой, и
 * клиент, обновляющий кнопку на плитке, обязан знать, о чьей плитке речь, не
 * храня соответствия «запрос и участник».
 *
 * ⚠️ **Необязательных полей здесь нет, и это не забывчивость.** Правило про
 * необязательное поле (`TokenResponse.capacity`) закрывает поле, ДОБАВЛЕННОЕ в
 * существующий ответ: в открытой вкладке крутится старый бандл, и ответ обязан
 * разбираться обеими версиями схемы. У нового маршрута старого читателя нет
 * вовсе: бандл, не знающий поля, не знает и адреса. Правило вернётся в силу с
 * первым же полем, дописанным сюда потом.
 */
export const MicResponse = z.object({
  userId: z.string().uuid(),
  micAllowed: z.boolean(),
});
export type MicResponse = z.infer<typeof MicResponse>;
